import PropTypes from "prop-types";
import React from "react";

class IconCheckbox extends React.PureComponent {
  static get propTypes() {
    return {
      checked: PropTypes.bool,
      icon: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      itemId: PropTypes.number.isRequired,
      onChange: PropTypes.func.isRequired,
    };
  }

  static get defaultProps() {
    return {
      checked: false,
    };
  }

  render() {
    const { checked, icon, itemId, label, onChange, ...rest } = this.props;
    const id = `icon-${itemId}`;

    return (
      <div className="icon-checkbox" {...rest}>
        <input
          type="checkbox"
          checked={checked}
          data-id={itemId}
          id={id}
          onChange={onChange}
        />
        <label htmlFor={id} className="clickable">
          <img src={icon} alt={label} />
          <span className="label-text">{label}</span>
        </label>
      </div>
    );
  }
}

export { IconCheckbox };
